import React from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_STUDIO_API_URL || 'http://localhost:4173/api/studio/v1';

const timezoneToMinutes = (value: any) => {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value !== 'string') return 0;

  const trimmed = value.trim();
  const match = trimmed.match(/^([+-]?)(\d{1,2})(?::?(\d{2}))?$/);
  if (!match) return 0;

  const sign = match[1] === '-' ? -1 : 1;
  return sign * (((Number(match[2]) || 0) * 60) + (Number(match[3]) || 0));
};

export const useCurrentTransitOverlay = (chartData: any, enabled: boolean, timing?: { date?: string; time?: string }) => {
  const [transitChart, setTransitChart] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (!enabled) {
      setTransitChart(null);
      setError(null);
      setLoading(false);
      return;
    }

    const place = chartData?.birthDetails?.placeOfBirth || {};
    const city = place.city || place.name || 'Birthplace';
    const latitude = Number(place.latitude);
    const longitude = Number(place.longitude);

    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
      setTransitChart(null);
      setError('Birthplace coordinates are missing.');
      setLoading(false);
      return;
    }

    let cancelled = false;

    const loadTransit = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await axios.post(`${API_BASE_URL}/charts/transit`, {
          city,
          latitude,
          longitude,
          timezoneOffset: timezoneToMinutes(place.timezone ?? place.timezoneOffset),
          ayanamshaMode: chartData?.calculationData?.ayanamshaMode || chartData?.ayanamshaMode || 'LAHIRI',
          ...(timing?.date && timing?.time ? { date: timing.date, time: timing.time } : {}),
        });

        if (!cancelled) {
          setTransitChart(response.data?.data?.chart || null);
        }
      } catch (err: any) {
        if (!cancelled) {
          setTransitChart(null);
          setError(err?.response?.data?.message || 'Failed to load current transit planets.');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadTransit();
    return () => { cancelled = true; };
  }, [chartData, enabled, timing?.date, timing?.time]);

  return { transitChart, loading, error };
};
